import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserStore } from 'stores/user';
import { Button, Loading, StrykerLogo } from 'ui';

import './splash.css';

const Splash = () => {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const isAuthed = UserStore.useState((s) => s.isAuthed);

  useEffect(() => {
    if (isAuthed) {
      navigate('/home');
    } else {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [isAuthed, navigate]);

  const navigateToLogin = () => {
    navigate('/login');
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="splash">
      <section className="splash-content">
        <StrykerLogo />
        <h1>
          Welcome to <span className="goldie-emphasis">Goldie</span>,
        </h1>
        <p>Stryker's in-house AI chatbot</p>
        <p>
          Your use and feedback of this app will help towards its continued
          improvement and development.
        </p>
        <Button onClick={navigateToLogin}>Continue</Button>
      </section>
      <div className="gradient-underlay" />
    </div>
  );
};

export default Splash;
